class CookieStorage {
    constructor(cookies) {
        this.cookies = decodeURIComponent(cookies);
    }
    async get(cname) {
        let name = cname + "=";
        let ca = this.cookies.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return new Promise((resolve) => {
                    resolve(c.substring(name.length, c.length));
                });
            }
        }
        return new Promise((resolve) => {
            resolve("");
        });
    }
    set(name, value) {
        throw new Error("Method not implemented.");
    }
    remove(name) {
        throw new Error("Method not implemented.");
    }
}
export default CookieStorage;
